<script setup>
import Button from '@components/forms/Button.vue'

defineProps(['data'])
</script>

<template>
	<section class="relative overflow-x-clip bg-snk-blue-900 bg-cover">
		<video class="absolute inset-0 h-full w-full object-cover" :src="data.cloudinary_id" autoplay muted loop playsinline />
		<div class="absolute h-full w-full bg-black/50" />
		<img class="absolute -left-36 -top-24 hidden lg:block xl:-top-11 xl:left-0" src="https://cdn.snkesports.com/events/images/elements/accents/hero-top-left.svg" aria-hidden="true" />
		<img class="absolute -bottom-24 -right-96 hidden lg:block xl:-right-60 2xl:-bottom-56 2xl:-right-14" src="https://cdn.snkesports.com/events/images/elements/accents/hero-bottom-right.svg" aria-hidden="true" />
		<!-- <img class="absolute left-0 top-0 w-full" src="https://cdn.snkesports.com/events/images/elements/accents/hero-accents.svg" aria-hidden="true" /> -->
		<div class="container">
			<div class="relative grid items-center gap-4 pb-10 pt-24 md:pb-28 md:pt-32 xl:grid-cols-2 xl:pb-32 xl:pt-40">
				<div class="flex flex-col items-start gap-8 text-white">
					<!-- <img class="max-h-32 sm:max-h-40 md:max-h-56" src="https://cdn.snkesports.com/events/images/logos/snk-world-championship-2026.png" alt="SNK World Championship 2026 (SWC 2026)" /> -->
					<div class="-h-32 sm:h-40 md:h-56" />
					<!-- <div class="label">SNK World Championship</div> -->
					<h1 v-if="data.title" v-html="data.title" style="white-space: pre-line" />
					<p v-if="data.description" v-html="data.description" style="white-space: pre-line" />
					<!-- <div class="flex gap-3"> -->
					<!-- <Button :to="{ name: 'index' }" class="solid light">Buy a Ticket</Button> -->
					<!-- <Button :to="{ name: 'article', params: { slug: 'swc-2026-everything-you-need-to-know' } }" class="solid swc">Learn More</Button> -->
					<!-- <Button :to="{ name: 'swc' }" class="solid swc" iconRight="far fa-arrow-up-right">SWC 2025</Button> -->
					<!-- </div> -->
				</div>
				<!-- <div class="hidden h-full items-end justify-end xl:flex">
					<a href="https://www.youtube.com/" target="_blank" class="group flex items-center gap-3 text-snk-light-500">
						<label class="text-right leading-none">
							Watch
							<br />
							Video
						</label>
						<i class="fas fa-chevron-right" />
						<div class="aspect-video h-52 rounded-xl border border-snk-blue-100/20 p-2 transition-all duration-300 group-hover:-translate-y-3 group-hover:border-snk-blue-400/80">
							<div class="relative flex h-full w-full items-center justify-center overflow-hidden rounded-lg bg-black transition-shadow duration-300 group-hover:shadow-2xl group-hover:shadow-snk-blue-500/65">
								<img class="absolute inset-0 h-full w-full object-cover" src="https://cdn.snkesports.com/events/images/backgrounds/tiles/atlanta.jpg" alt="" />
								<div class="absolute flex h-16 w-16 items-center justify-center rounded-full backdrop-blur transition-colors duration-300 group-hover:bg-snk-blue-500">
									<i class="fas fa-play -mr-1 text-3xl" />
								</div>
							</div>
						</div>
					</a>
				</div> -->
			</div>
		</div>
	</section>
</template>
